import { defineComponent as n, createElementBlock as t, createCommentVNode as r, openBlock as i, normalizeClass as l, toDisplayString as a } from "vue";
const o = ["href"], s = /* @__PURE__ */ n({
  __name: "HeaderItemLink",
  props: {
    link: {}
  },
  setup(e) {
    return (k, c) => e.link.show ? (i(), t("a", {
      key: 0,
      class: l(["header-item-link", { "header-item-link__cta": e.link.isButton }]),
      href: e.link.link || "#",
      rel: "noopener noreferrer",
      target: "_blank"
    }, a(e.link.title), 11, o)) : r("", !0);
  }
});
export {
  s as default
};
